{
  "version": 1,
  "asset_id": "385c82b7-691e-4c79-8d1a-a488dab95e6d",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/385c82b7-691e-4c79-8d1a-a488dab95e6d/groen-water-480.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/385c82b7-691e-4c79-8d1a-a488dab95e6d/groen-water-480.avif",
  "original_filename": "groen-water-480.avif",
  "size": 5061,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:44Z"
}
